import src from "IMAGE";
export default { src, width: 52, height: 59, blurWidth: 0, blurHeight: 0};
